import logo from './assets/logo.png';
import './App.css';
import React from 'react';
import { BrowserRouter, Routes, Route, Outlet, Navigate } from 'react-router-dom';
import Header from "./components/Header";
import Footer from './components/Footer';
import MobileNav from './components/MobileNav';
import NotFound from './screens/NotFound';
import Main from "./screens/Main";
import SectionLayout from './components/SectionLayout';

// MetaAI 레이아웃 + 자식 페이지들
import MetaAIAbout from './screens/metaai/MetaAIAbout';
import MetaAIHistory from './screens/metaai/MetaAIHistory';
import MetaAILocation from './screens/metaai/MetaAILocation';

// Business 레이아웃 + 자식 페이지들
import AIProduct from "./screens/business/ai/AIProduct";
import AIResearch from "./screens/business/ai/AIResearch";
import AIEducation from "./screens/business/ai/AIEducation";
import AIPapers from "./screens/business/ai/AIPapers";

import SecProduct from "./screens/business/security/SecProduct";
import SecResearch from "./screens/business/security/SecResearch";

// Customer 레이아웃 + 자식 페이지들
import CustomerList from "./screens/customer/CustomerList";
import CustomerPartner from "./screens/customer/CustomerPartner";

// Service Demo 레이아웃 + 자식 페이지들
import Documan from "./screens/service/Documan";

// 모바일 드로어에 표시할 카테고리
const mobileSections = [
  {
    title: "MetaAI",
    items: [
      { label: "회사소개",  href: "/metaai/about" },
      { label: "연혁",   href: "/metaai/history" },
      { label: "위치",  href: "/metaai/location" },
    ],
  },
  {
    title: "Business",
    items: [
      {
        title: "AI",   // ← 그룹 제목
        items: [
          { label: "제품소개", href: "/business/ai/product" }, 
          { label: "연구개발", href: "/business/ai/research" }, 
          { label: "교육", href: "/business/ai/education" }, 
          { label: "논문 및 특허", href: "/business/ai/papers" },
        ],
      },
      {
        title: "Security",
        items: [
          { label: "제품소개", href: "/business/security/product" }, 
          { label: "연구개발", href: "/business/security/research" }, 
        ],
      },
    ],
  },
  {
    title: "Customer",
    items: [
      { label: "고객사",     href: "/customer/list" },
      { label: "비즈니스 협력", href: "/customer/partner" },
    ],
  },
  {
    title: "Service Demo",
    items: [
      { label: "AI.DocuMan", href: "/service/documan" },
    ],
  },
];

const App = () => {
  return (
    <div className="App">
      <BrowserRouter>
        {/* 모바일 전용 드로어 네비 (1024px 미만에서만 보임) */}
        <MobileNav brand="MetaAI" logoSrc={logo} sections={mobileSections} />
        <Header />
        <Routes>
          <Route path="/" element={<Main />} />

          {/* MetaAI */}
          <Route 
            path="/metaai/*" 
            element={
              <SectionLayout 
                title="MetaAI"
                tabs={[
                  { to: "/metaai/about", label: "회사소개", end: true },
                  { to: "/metaai/history", label: "연혁" },
                  { to: "/metaai/location", label: "위치" },
                ]}
              />
            } 
          >
            <Route index element={<MetaAIAbout />} />
            <Route path="about" element={<MetaAIAbout />} />
            <Route path="history" element={<MetaAIHistory />} />
            <Route path="location" element={<MetaAILocation />} />
            <Route path="*" element={<NotFound />} />
          </Route>

          {/* Business */}
          <Route path="/business" element={<Outlet />}>
            <Route index element={<Navigate to="ai/product" replace />} />
            <Route
              path="ai/*"
              element={
                <SectionLayout
                  title="AI"
                  tabs={[
                    { to: "/business/ai/product", label: "제품소개" },
                    { to: "/business/ai/research", label: "연구개발" },
                    { to: "/business/ai/education", label: "교육" },
                    { to: "/business/ai/papers", label: "논문 및 특허" },
                  ]}
                />
              }
            >
              <Route index element={<AIProduct />} />
              <Route path="product" element={<AIProduct />} />
              <Route path="research" element={<AIResearch />} />
              <Route path="education" element={<AIEducation />} />
              <Route path="papers" element={<AIPapers />} />
              <Route path="*" element={<NotFound />} />
            </Route>

            <Route
              path="security/*"
              element={
                <SectionLayout
                  title="Security"
                  tabs={[
                    { to: "/business/security/product", label: "제품소개" },
                    { to: "/business/security/research", label: "연구개발" },
                  ]}
                />
              }
            >
              <Route index element={<SecProduct />} />
              <Route path="product" element={<SecProduct />} />
              <Route path="research" element={<SecResearch />} />
              <Route path="*" element={<NotFound />} />
            </Route>
            <Route path="*" element={<NotFound />} />
          </Route>

          {/* Customer */}
          <Route
            path="/customer/*"
            element={
              <SectionLayout
                title="Customer"
                tabs={[
                  { to: "/customer/list", label: "고객사" },
                  { to: "/customer/partner", label: "비즈니스 협력" },
                ]}
              />
            }
          >
            <Route index element={<CustomerList />} />
            <Route path="list" element={<CustomerList />} />
            <Route path="partner" element={<CustomerPartner />} />
            <Route path="*" element={<NotFound />} />
          </Route>

          {/* Service Demo */}
          <Route
            path="/service/*"
            element={
              <SectionLayout
                title="Service Demo"
                tabs={[
                  { to: "/service/documan", label: "AI.DocuMan" },
                ]}
              />
            }
          >
            <Route index element={<Documan />} />
            <Route path="documan" element={<Documan />} />
            <Route path="*" element={<NotFound />} />
          </Route>

          <Route path="*" element={<NotFound />} />
        </Routes>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
